// R8-MAN — logica pura del form listino, estratta per essere testabile senza
// @testing-library (non nel progetto): stesso pattern di ficEsiti.js / mfaTesti.js.
// ⛔ LIMITE (come ficEsiti): questa prova dimostra la logica, NON che Listino.jsx la
// usi. Il giorno che @testing-library entra nel progetto, la prova sale al componente.

export const UNITA_LISTINO = ['sacchi', 'mq', 'ml', 'mc', 'kg', 'pz'];

// R8-CAT — palette colori categoria. RISPECCHIA i token di Documenti (COLORE_PALETTE in
// components/documenti/VistaGriglia.jsx) e la lista backend PALETTE_CATEGORIA: un solo
// vocabolario di colori nel prodotto (contratto: nessuno stile nuovo). Si memorizza il NOME
// del colore; qui il nome->hex per disegnare la card.
export const COLORE_PALETTE = [
  { name: 'amber', hex: '#FFB300' }, { name: 'green', hex: 'var(--brand)' },
  { name: 'blue', hex: '#4458A8' }, { name: 'purple', hex: '#8E24AA' },
  { name: 'red', hex: '#E53E3E' }, { name: 'gray', hex: '#9E9E9E' },
  { name: 'teal', hex: '#0c8599' }, { name: 'coral', hex: '#FF6B6B' },
  // R8-CAT — 4 tinte aggiunte (8→12) per distinguere più categorie senza riusare i colori.
  { name: 'orange', hex: '#E8590C' }, { name: 'pink', hex: '#D6336C' },
  { name: 'lime', hex: '#74B816' }, { name: 'brown', hex: '#8D6E4F' },
];

// R8-CAT — dal NOME del colore all'hex per disegnare. Colore assente/sconosciuto -> grigio muto.
export function coloreHex(nome) {
  const c = COLORE_PALETTE.find((p) => p.name === nome);
  return c ? c.hex : 'var(--ds-muted)';
}

// R8-CAT — etichetta conteggio voci di una card categoria: "vuota" / "1 voce" / "N voci".
export function etichettaConteggio(n) {
  const num = Number(n) || 0;
  if (num <= 0) return 'vuota';
  return num === 1 ? '1 voce' : `${num} voci`;
}

// Un form è salvabile solo con descrizione non vuota e un prezzo indicato.
export function formValido(form) {
  return Boolean(form && String(form.descrizione || '').trim()) &&
    form.prezzo_unitario !== '' && form.prezzo_unitario !== null &&
    form.prezzo_unitario !== undefined;
}

// Payload inviato all'API /api/listino/: trim su testo, prezzo/unità/categoria come sono.
export function costruisciPayload(form) {
  return {
    descrizione: String(form.descrizione || '').trim(),
    prezzo_unitario: form.prezzo_unitario,
    unita_misura: form.unita_misura || '',
    categoria: String(form.categoria || '').trim(),
    // R9-QTA — la voce eredita la metratura generale dell'appartamento quando dettata
    // senza quantità (Vale spunta quali dal pannello). Default false.
    eredita_metratura: Boolean(form.eredita_metratura),
  };
}

// R8-IMP-UX — messaggio d'esito dell'import PDF, in base al numero di voci estratte.
export function messaggioImport(n) {
  const num = Number(n) || 0;
  if (num <= 0) return 'Non ho trovato voci di listino in questo PDF.';
  const voci = num === 1 ? 'voce' : 'voci';
  return `Estratte ${num} ${voci}: controllale e correggi i prezzi se serve.`;
}

// FE-085 — AMBITO dell'eliminazione, detto a parole: cosa sta per sparire.
// Ricerca prima della categoria, come in `filtroVoci` di Listino.jsx (la ricerca
// scavalca la categoria aperta).
export function ambitoEliminazione(search, categoriaAttiva) {
  const q = String(search || '').trim();
  if (q) return `trovate per «${q}» in tutto il listino`;
  if (categoriaAttiva && categoriaAttiva.senza) return 'senza categoria';
  if (categoriaAttiva && categoriaAttiva.nome) return `della categoria «${categoriaAttiva.nome}»`;
  return '';
}

// FE-085 — testi della finestra di conferma (Regola 14: niente window.confirm).
// `n` e' il numero che il SERVER ha contato (anteprima) o quello delle voci
// spuntate a mano; `cambiato` = il server ha risposto 409, cioe' nel frattempo le
// voci del filtro sono cambiate e la conferma va ridata sul numero nuovo.
export function testiConfermaElimina({ n, ambito, cambiato }) {
  const num = Number(n) || 0;
  const voci = num === 1 ? 'voce' : 'voci';
  const dove = ambito ? ` ${ambito}` : '';
  const testo = cambiato
    ? `Nel frattempo le voci sono diventate ${num}: conferma di nuovo. Stai per eliminare ${num} ${voci}${dove}. L'azione non è reversibile.`
    : `Stai per eliminare ${num} ${voci}${dove}. L'azione non è reversibile.`;
  return {
    titolo: num === 1 ? 'Eliminare 1 voce?' : `Eliminare ${num} voci?`,
    testo,
    bottone: num === 1 ? 'Elimina 1 voce' : `Elimina ${num} voci`,
  };
}

// FE-085 — il 409 di elimina-filtrate porta il conteggio e l'impronta NUOVI.
// Restituisce { conteggio, impronta } solo se la risposta e' davvero quella;
// qualunque altro errore -> null (il chiamante mostra l'errore generico).
export function rifiutoInsiemeCambiato(err) {
  const r = err && err.response;
  if (!r || r.status !== 409 || !r.data) return null;
  const { conteggio, impronta } = r.data;
  if (typeof conteggio !== 'number' || typeof impronta !== 'string' || !impronta) return null;
  return { conteggio, impronta };
}

// R8-MAN-MULTI — esito dell'eliminazione batch.
export function messaggioEliminate(n) {
  const num = Number(n) || 0;
  return num === 1 ? '1 voce eliminata.' : `${num} voci eliminate.`;
}

// R8-AGG — etichetta di un suggerimento del listino nell'autocomplete preventivo:
// "Cartongesso — € 50,00 / mq" (prezzo formato IT, unità solo se presente).
export function etichettaSuggerimento(voce) {
  const desc = String((voce && voce.descrizione) || '').trim();
  // Number(null) e Number('') danno 0 (non NaN): un prezzo assente NON deve
  // diventare "€ 0,00". Un vero 0 (prezzo lecito) invece sì.
  const raw = voce && voce.prezzo_unitario;
  const p = (raw === null || raw === undefined || raw === '') ? NaN : Number(raw);
  const prezzoStr = Number.isFinite(p) ? `€ ${p.toFixed(2).replace('.', ',')}` : '';
  const unita = String((voce && voce.unita_misura) || '').trim();
  let out = desc;
  if (prezzoStr) out += ` — ${prezzoStr}`;
  if (prezzoStr && unita) out += ` / ${unita}`;
  return out;
}

// R8-AGG — cerca nel listino solo da 2 caratteri: evita rumore e di scaricare tutto.
export function deveCercareListino(testo) {
  return String(testo || '').trim().length >= 2;
}

// R8-AGG — se i suggerimenti mostrati sono meno del totale che matcha la ricerca,
// avvisa che ce ne sono altri (invito ad affinare invece di scaricarli tutti).
export function etichettaAltre(totale, mostrate) {
  const resto = (Number(totale) || 0) - (Number(mostrate) || 0);
  return resto > 0 ? `+ altre ${resto} — scrivi di più per affinare` : '';
}

// R8-IMP-DEDUP — esito import con conteggi dedup: "N nuove, M aggiornate, K da verificare".
export function messaggioEsitoImport(job) {
  const n = Number(job && job.create) || 0;
  const a = Number(job && job.aggiornate) || 0;
  const k = Number(job && job.da_verificare) || 0;
  if (n + a + k === 0) return 'Non ho trovato voci di listino in questo PDF.';
  const parti = [];
  if (n) parti.push(`${n} ${n === 1 ? 'nuova' : 'nuove'}`);
  if (a) parti.push(`${a} ${a === 1 ? 'aggiornata' : 'aggiornate'}`);
  if (k) parti.push(`${k} da verificare`);
  return `Import completato: ${parti.join(', ')}.`;
}

// R8-IMP-DEDUP — badge di una voce col prezzo aggiornato da un re-import: "€ 50,00 → € 55,00".
export function etichettaAggiornata(voce) {
  if (!voce || voce.stato_import !== 'aggiornata') return '';
  const p = (x) => `€ ${(Number(x) || 0).toFixed(2).replace('.', ',')}`;
  return `${p(voce.prezzo_precedente)} → ${p(voce.prezzo_unitario)}`;
}
